<template>
  <v-alert
    v-if="updateAvailable"
    type="info"
    variant="tonal"
    density="comfortable"
    class="app-version-update-banner"
  >
    <div class="app-version-update-banner__content">
      <div>
        Hay una versión nueva de la aplicación. Recarga para usarla.
      </div>
      <v-btn color="info" variant="flat" size="small" @click="reloadNow">
        Recargar
      </v-btn>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useAppVersionCheck } from '@/composables/useAppVersionCheck'

export default defineComponent({
  name: 'AppVersionUpdateBanner',

  setup() {
    const { updateAvailable, reloadNow } = useAppVersionCheck()

    return {
      updateAvailable,
      reloadNow,
    }
  },
})
</script>

<style scoped>
.app-version-update-banner {
  position: relative;
  z-index: 1;
  border-radius: 0;
  background: rgb(var(--v-theme-surface)) !important;
}

.app-version-update-banner :deep(.v-alert__underlay) {
  opacity: 1;
  background: rgba(var(--v-theme-info), 0.16) !important;
}

.app-version-update-banner__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
</style>
